export default __webpack_public_path__ + "static/signature-27509072d47df4b1f20278e7445a2afd.jpg";